import * as types from './eventTypes';

export default function pushToRetailRocket(type, data) {
  const RRApi = window.rrApiOnReady && window.RRApi;

  if (!RRApi) {
    console.warn('Unable to push event to RetailRocket, API unavailable');
    return false;
  }

  try {
    switch (type) {
      case types.EVENT_ADD_TO_CART:
        RRApi.addToBasket(data.productId);
        break;
      default:
        return false;
    }
  } catch (e) {
    console.warn(`Internal RetailRocket error occurred while trying to push '${type}'`);
  }

  return true;
}
